module.exports = __webpack_public_path__ + "img/network.b3696186.jpg";